<dashboardnav>
  <cradua-counsel-type [counseltypes]="counseltypes$ | async" (counseltype)="onSubmitCounselType($event)"
    (deleteCounselTypeEvent)="onDeleteCounselType($event)" *ngIf="(isLoadingCounselType$ | async ) === false">
  </cradua-counsel-type>

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingCounselType$ | async) === true">
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
